import { Button, Dialog } from "iron-man";
import React, { useState } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { getCurrentLang } from "@/function/utils.js";

const ToopTipDialog = (props) => {
  const { openModal, handleResetDialog, openPolicy } = props;
  const [isOpen, setIsOpen] = useState(openModal);
  const lang = getCurrentLang();
  const { t } = useTranslation();
  const onCancel = () => {
    setIsOpen(false);
    handleResetDialog();
  };
  const onClose = () => {
    setIsOpen(false);
    handleResetDialog();
  };
  const onOk = () => {
    setIsOpen(false);
    handleResetDialog();
  };

  return (
    <div style={{ zIndex: 9999, marginTop: "200px" }}>
      <Dialog title="" isShowFoot={false} isOpen={isOpen} onCancel={onCancel} onClose={onClose} onOk={onOk}>
        {openPolicy ? (
          lang === "ch" ? (
            // 显示保单号码
            <PDFImage>
              <ImgInner src={`${process.env.PUBLIC_URL}/images/policy-no_tips_001.jpg`} />
              <ImgInner src={`${process.env.PUBLIC_URL}/images/policy-no_tips_002.jpg`} />
              <ImgInner src={`${process.env.PUBLIC_URL}/images/policy-no_tips_003.jpg`} />
              <ImgInner src={`${process.env.PUBLIC_URL}/images/policy-no_tips_004.jpg`} />
            </PDFImage>
          ) : (
            <PDFImage>
              <ImgInner src={`${process.env.PUBLIC_URL}/images/policy-no_tips_001_en.jpg`} />
              <ImgInner src={`${process.env.PUBLIC_URL}/images/policy-no_tips_002_en.jpg`} />
              <ImgInner src={`${process.env.PUBLIC_URL}/images/policy-no_tips_003_en.jpg`} />
              <ImgInner src={`${process.env.PUBLIC_URL}/images/policy-no_tips_004_en.jpg`} />
            </PDFImage>
          )
        ) : (
          // 显示受保人
          <DialogContent>
            <TitleDiv>{t("translation:findPolicyDialog.title")}</TitleDiv>
            <SubTitleDiv>{t("translation:findPolicyDialog.subTitle")}</SubTitleDiv>
            <div>
              <PhotoTitle>{t("translation:findPolicyDialog.email")} </PhotoTitle>
              <Img440 src={`${process.env.PUBLIC_URL}/images/tooltip1.png`} alt="電郵（團體保險）" />
            </div>
            <PhotoTitle>{t("translation:findPolicyDialog.medicalCard")} </PhotoTitle>
            <MedicalCardContaner>
              <MedicalCard src={`${process.env.PUBLIC_URL}/images/tooltip21.png`} alt="醫療卡" />
              <MedicalCard src={`${process.env.PUBLIC_URL}/images/tooltip22.png`} alt="醫療卡" />
            </MedicalCardContaner>
            <div>
              <PhotoTitle>{t("translation:findPolicyDialog.policy")} </PhotoTitle>
              <Img440 src={`${process.env.PUBLIC_URL}/images/tooltip3.png`} alt="保單（團體保險）" />
            </div>
          </DialogContent>
        )}
      </Dialog>
    </div>
  );
};
const DialogContent = styled.div`
  height: 450px;
  overflow: auto;
  width: 100%;
  padding: 0 100px;

  display: flex;
  flex-direction: column;
  align-item: center;
  @media (max-width: 750px) {
    padding: 0;
  }
`;
const MedicalCardContaner = styled.div`
  width: 460px;
  display: flex;
  gap: 24px;
  @media (max-width: 750px) {
    width: 276px;
    margin-top: 24px;
    flex-direction: column;
    gap: 0;
  }
`;
const MedicalCard = styled.img`
  width: 240px;
  height: 149px;
`;
const TitleDiv = styled.div`
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  text-align: center;
  color: #005697;
`;

const SubTitleDiv = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
  color: #262626;
`;
const Img440 = styled.img`
  width: 460px;
  @media (max-width: 750px) {
    width: 276px;
    margin-top: 24px;
  }
`;
const PhotoTitle = styled.div`
  margin-top: 32px;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0px;
  text-decoration: underline;
  text-decoration-style: solid;
  color: #262626;
`;
const PDFImage = styled.div`
  height: 450px;
  width: 460px;
  display: flex;
  flex-direction: column;
  align-items: center; /* 垂直居中对齐 */
  overflow: auto;
  @media (max-width: 460px) {
    width: 100%;
  }
`;
const ImgInner = styled.img`
  width: 240px;
  @media (max-width: 426px) {
    width: 100%;
  }
  object-fit: contain;
  margin-top: 24px;
`;
export default ToopTipDialog;
